// extracted by mini-css-extract-plugin
export var primitiveLabel = "_td-0";